import {
  ChartLineUp,
  Gear,
  House,
  Toolbox,
  UsersThree,
} from "@phosphor-icons/react";
import { Link, useLocation, } from "react-router-dom";

const NavbarAdmin = () => {
  const pathActive = useLocation();

  return (
    <nav
      className={
        pathActive.pathname === "/login" ||
        pathActive.pathname === "/register" ||
        pathActive.pathname === "/edit-profile"
          ? "hidden"
          : "fixed bottom-0 bg-slate-100 h-20 w-full shadow-inner flex items-center justify-evenly"
      }
    >
      <Link
        to="/admin"
        className="flex flex-col cursor-pointer gap-1 items-center justify-center"
      >
        <House
          size="26"
          weight={pathActive.pathname === "/admin" ? "fill" : "regular"}
          color={pathActive.pathname === "/admin" ? "black" : "gray"}
        />
        <p
          className={
            pathActive.pathname === "/admin"
              ? "text-xs text-black font-semibold"
              : "text-xs text-gray-500 font-semibold"
          }
        >
          Home
        </p>
      </Link>
      <Link
        to="/admin/analysis"
        className="flex flex-col cursor-pointer gap-1 items-center justify-center"
      >
        <ChartLineUp
          size="26"
          weight={pathActive.pathname === "/admin/analysis" ? "fill" : "regular"}
          color={pathActive.pathname === "/admin/analysis" ? "black" : "gray"}
        />
        <p
          className={
            pathActive.pathname === "/admin/analysis"
              ? "text-xs text-black font-semibold"
              : "text-xs text-gray-500 font-semibold"
          }
        >
          Analytics
        </p>
      </Link>
      <Link
        to="/logistics"
        className="flex flex-col cursor-pointer gap-1 items-center justify-center"
      >
        <Toolbox
          size="26"
          weight={pathActive.pathname === "/logistics" ? "fill" : "regular"}
          color={pathActive.pathname === "/logistics" ? "black" : "gray"}
        />
        <p
          className={
            pathActive.pathname === "/logistics"
              ? "text-xs text-black font-semibold"
              : "text-xs text-gray-500 font-semibold"
          }
        >
          Logistics
        </p>
      </Link>
      <Link
        to="/admin/data-user"
        className="flex flex-col cursor-pointer gap-1 items-center justify-center"
      >
        <UsersThree
          size="26"
          weight={pathActive.pathname === "/admin/data-user" ? "fill" : "regular"}
          color={pathActive.pathname === "/admin/data-user" ? "black" : "gray"}
        />
        <p
          className={
            pathActive.pathname === "/admin/data-user"
              ? "text-xs text-black font-semibold"
              : "text-xs text-gray-500 font-semibold"
          }
        >
          Users
        </p>
      </Link>
      <Link
        to="/settings"
        className="flex flex-col cursor-pointer gap-1 items-center justify-center"
      >
        <Gear
          size="26"
          weight={pathActive.pathname === "/settings" ? "fill" : "regular"}
          color={pathActive.pathname === "/settings" ? "black" : "gray"}
        />
        <p
          className={
            pathActive.pathname === "/settings"
              ? "text-xs text-black font-semibold"
              : "text-xs text-gray-500 font-semibold"
          }
        >
          Settings
        </p>
      </Link>
    </nav>
  );
};

export default NavbarAdmin;
